import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeVehicleTypeMutationVariables = Types.Exact<{
  input: Types.MergeVehicleTypeInput;
}>;


export type MergeVehicleTypeMutation = { __typename?: 'Mutation', mergeVehicleType: { __typename?: 'VehicleTypePayload', vehicleType?: { __typename?: 'VehicleTypeStateData', tenantId: string, vehicleTypeId: string, name: string, notes: string, maxLoadWeight?: number | null, maxLoadWeightUnit: Types.WeightUnit, maxLoadWeightLbs?: number | null, updatedAt: Types.TDateISO, updatedBy: string, capacities: Array<{ __typename?: 'VehicleTypeCapacityStateData', containerConfigId: string, containerName: string, maxCount: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteVehicleTypeMutationVariables = Types.Exact<{
  input: Types.DeleteVehicleTypeInput;
}>;


export type DeleteVehicleTypeMutation = { __typename?: 'Mutation', deleteVehicleType: { __typename?: 'VehicleTypePayload', vehicleType?: { __typename?: 'VehicleTypeStateData', tenantId: string, vehicleTypeId: string, name: string, notes: string, maxLoadWeight?: number | null, maxLoadWeightUnit: Types.WeightUnit, maxLoadWeightLbs?: number | null, updatedAt: Types.TDateISO, updatedBy: string, capacities: Array<{ __typename?: 'VehicleTypeCapacityStateData', containerConfigId: string, containerName: string, maxCount: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsVehicleTypeStateFieldsFragment = { __typename?: 'VehicleTypeStateData', tenantId: string, vehicleTypeId: string, name: string, notes: string, maxLoadWeight?: number | null, maxLoadWeightUnit: Types.WeightUnit, maxLoadWeightLbs?: number | null, updatedAt: Types.TDateISO, updatedBy: string, capacities: Array<{ __typename?: 'VehicleTypeCapacityStateData', containerConfigId: string, containerName: string, maxCount: number }> };

export const LogisticsVehicleTypeStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsVehicleTypeStateFields on VehicleTypeStateData {
  tenantId
  vehicleTypeId
  name
  notes
  capacities {
    containerConfigId
    containerName
    maxCount
  }
  maxLoadWeight
  maxLoadWeightUnit
  maxLoadWeightLbs
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsVehicleTypeStateFields"});
export const MergeVehicleTypeDocument = new TypedDocumentString(`
    mutation MergeVehicleType($input: MergeVehicleTypeInput!) {
  mergeVehicleType(input: $input) {
    vehicleType {
      ...LogisticsVehicleTypeStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsVehicleTypeStateFields on VehicleTypeStateData {
  tenantId
  vehicleTypeId
  name
  notes
  capacities {
    containerConfigId
    containerName
    maxCount
  }
  maxLoadWeight
  maxLoadWeightUnit
  maxLoadWeightLbs
  updatedAt
  updatedBy
}`);
export const DeleteVehicleTypeDocument = new TypedDocumentString(`
    mutation DeleteVehicleType($input: DeleteVehicleTypeInput!) {
  deleteVehicleType(input: $input) {
    vehicleType {
      ...LogisticsVehicleTypeStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsVehicleTypeStateFields on VehicleTypeStateData {
  tenantId
  vehicleTypeId
  name
  notes
  capacities {
    containerConfigId
    containerName
    maxCount
  }
  maxLoadWeight
  maxLoadWeightUnit
  maxLoadWeightLbs
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeVehicleType: build.mutation<MergeVehicleTypeMutation, MergeVehicleTypeMutationVariables>({
      query: (variables) => ({ document: MergeVehicleTypeDocument, variables })
    }),
    DeleteVehicleType: build.mutation<DeleteVehicleTypeMutation, DeleteVehicleTypeMutationVariables>({
      query: (variables) => ({ document: DeleteVehicleTypeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeVehicleTypeMutation, useDeleteVehicleTypeMutation } = injectedRtkApi;
